import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '../themes';

class Loader extends React.PureComponent {
  render() {
    const { isFetching } = this.props;
    const isShowingClass = isFetching ? 'showing' : '';
    return (
      <div className={`wrap ${isShowingClass}`}>
        <div className="loader" />
        <style jsx>
          {`
            .wrap {
              position: fixed;
              left: 50%;
              transform: scale(0);
              transition: transform 0.1s ease-in-out;
              will-change: transform;
              margin-left: -1em;
              z-index: 888;
              bottom: 30px;
              background: #fff;
              border-radius: 50%;
              padding: 5px;
              box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.25);
            }
            .wrap.showing {
              transform: scale(1);
            }
            .loader,
            .loader:after {
              border-radius: 50%;
              width: 3em;
              height: 3em;
            }
            .loader {
              margin: auto;
              font-size: 0.625em; /* 10/16 */
              position: relative;
              text-indent: -9999em;
              border: 0.3em solid ${colors.grayExtraLight};
              border-left-color: ${colors.blue};
              transform: translateZ(0);
              animation: rotate 1.1s infinite linear;
            }
            @keyframes rotate {
              0% {
                transform: rotate(0deg);
              }
              100% {
                transform: rotate(360deg);
              }
            }
          `}
        </style>
      </div>
    );
  }
}

Loader.propTypes = {
  isFetching: PropTypes.bool.isRequired,
};

export default Loader;



// WEBPACK FOOTER //
// ./app/common/Loader.js